import { Component, HostListener, Input, OnInit } from '@angular/core';
import { SignupWizardService } from '../signup-wizard.service';

@Component({
  standalone: false,
  selector: 'sbnb-signup-header',
  templateUrl: './signup-header.component.html',
  styleUrls: ['./signup-header.component.scss'],
})
export class SignupHeaderComponent implements OnInit {
  @Input() hideActions: boolean = false; // force hide the back and close button

  constructor(public wizard: SignupWizardService) { }

  ngOnInit() { }

  hasPrev() {
    return this.wizard.hasPrevious();
  }

  gotoPrev() {
    this.wizard.previous();
  }

  cancelWizard() {
    this.wizard.marketing();
  }

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event): void {
    if (this.wizard.signupUser.token) {
      this.wizard.stashUserInLocalStorage();
    }

    // event.returnValue = false;
  }
}
